import React, { useState } from "react";
import { api } from "../lib/api";
import { Mail, MessageCircle, MapPin } from "lucide-react";
import { toast } from "sonner";

const init = { name: "", email: "", subject: "", message: "" };

export default function Contact() {
    const [f, setF] = useState(init);
    const [loading, setLoading] = useState(false);

    const set = (k, v) => setF((prev) => ({ ...prev, [k]: v }));

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/contact", f);
            toast.success("Our concierge will be in touch shortly.");
            setF(init);
        } catch {
            toast.error("Please check your details and try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="max-w-[1200px] mx-auto px-6 md:px-12 pt-16 pb-32"
            data-testid="contact-page"
        >
            <div className="overline mb-4">Private concierge</div>
            <h1
                className="font-serif text-5xl sm:text-6xl tracking-tight mb-6"
                style={{ color: "var(--vl-text)" }}
            >
                We'd love to{" "}
                <em
                    style={{
                        color: "var(--vl-rose)",
                        fontStyle: "italic",
                    }}
                >
                    hear from you.
                </em>
            </h1>
            <p
                className="max-w-xl"
                style={{
                    color: "var(--vl-muted)",
                    lineHeight: 1.8,
                }}
            >
                Questions about formulations, returns, or recommendations —
                our concierge answers every note, privately.
            </p>

            <div className="mt-14 grid lg:grid-cols-12 gap-10">
                <form
                    onSubmit={submit}
                    className="lg:col-span-7 space-y-6"
                    data-testid="contact-form"
                >
                    <div className="grid sm:grid-cols-2 gap-6">
                        <input
                            required
                            placeholder="Your name"
                            className="vl-input"
                            value={f.name}
                            onChange={(e) => set("name", e.target.value)}
                            data-testid="contact-name"
                        />
                        <input
                            required
                            type="email"
                            placeholder="Email"
                            className="vl-input"
                            value={f.email}
                            onChange={(e) => set("email", e.target.value)}
                            data-testid="contact-email"
                        />
                    </div>
                    <input
                        required
                        placeholder="Subject"
                        className="vl-input"
                        value={f.subject}
                        onChange={(e) => set("subject", e.target.value)}
                        data-testid="contact-subject"
                    />
                    <textarea
                        required
                        rows={6}
                        placeholder="Your message"
                        className="vl-input"
                        value={f.message}
                        onChange={(e) => set("message", e.target.value)}
                        data-testid="contact-message"
                        style={{ resize: "vertical" }}
                    />
                    <button
                        type="submit"
                        className="vl-btn vl-btn-solid"
                        disabled={loading}
                        data-testid="contact-submit"
                    >
                        {loading ? "Sending…" : "Send privately"}
                    </button>
                </form>

                <aside
                    className="lg:col-span-5 p-8 h-fit"
                    style={{
                        background: "var(--vl-surface)",
                        border: "1px solid var(--vl-border)",
                    }}
                >
                    <div className="overline mb-6">Other ways to reach us</div>
                    <div className="space-y-6">
                        <div className="flex gap-4">
                            <MessageCircle
                                size={18}
                                strokeWidth={1.25}
                                color="var(--vl-rose)"
                            />
                            <div>
                                <div
                                    className="text-sm"
                                    style={{ color: "var(--vl-text)" }}
                                >
                                    WhatsApp concierge
                                </div>
                                <div
                                    className="text-xs mt-1"
                                    style={{ color: "var(--vl-muted)" }}
                                >
                                    +91 9999 999 999 · Mon–Fri 10am–8pm IST
                                </div>
                            </div>
                        </div>
                        <div className="flex gap-4">
                            <Mail
                                size={18}
                                strokeWidth={1.25}
                                color="var(--vl-rose)"
                            />
                            <div>
                                <div
                                    className="text-sm"
                                    style={{ color: "var(--vl-text)" }}
                                >
                                    concierge@veloura.com
                                </div>
                                <div
                                    className="text-xs mt-1"
                                    style={{ color: "var(--vl-muted)" }}
                                >
                                    Replies within one business day.
                                </div>
                            </div>
                        </div>
                        <div className="flex gap-4">
                            <MapPin
                                size={18}
                                strokeWidth={1.25}
                                color="var(--vl-rose)"
                            />
                            <div>
                                <div
                                    className="text-sm"
                                    style={{ color: "var(--vl-text)" }}
                                >
                                    Veloura Atelier, Mumbai
                                </div>
                                <div
                                    className="text-xs mt-1"
                                    style={{ color: "var(--vl-muted)" }}
                                >
                                    By appointment only.
                                </div>
                            </div>
                        </div>
                    </div>
                </aside>
            </div>
        </div>
    );
}
